import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1e6480bb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1e6480bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6480bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e6480bb')) {
      api.createRecord('1e6480bb', component.options)
    } else {
      api.reload('1e6480bb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1e6480bb&scoped=true&", function () {
      api.rerender('1e6480bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/CargoPopSelectInput/index.vue"
export default component.exports